/**
 * usecase 共通の認証スコープ。
 * usecase が React の AuthProvider に依存しないよう、フックが authUser から AuthScope を作って渡す。
 */
export interface AuthScope {
  role: "root" | "admin" | "shop" | "user";
  shopId: string | null;
  companyId: string | null;
}

/** useAuth().authUser → AuthScope */
export function toScope(
  authUser:
    | { role?: string | null; shop_id?: string | null; company_id?: string | null }
    | null
    | undefined,
): AuthScope {
  return {
    role: (authUser?.role as AuthScope["role"]) ?? "user",
    shopId: authUser?.shop_id ?? null,
    companyId: authUser?.company_id ?? null,
  };
}
